/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';
import _ from 'lodash';
import { Typeahead } from 'react-bootstrap-typeahead';
import Checkbox from '@tds/core-checkbox';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import PasswordMessage from './passwordMessage';
import { Wrapper, Box } from './css';
import RegistrationModal from './modal';
import { getLocalizedStrings } from '../misc';

import {
  RECAPTCHA_SITE_KEY,
  channels,
  referalChannels,
  CONSTANT,
  channelOutletMapping,
  storeCodeOutletMapping,
  outletIdStoreCodeMapping
} from '../utils/constant';
import { useTranslationsContext } from '../context/TranslationsContext';
import RestChannelsForm from './forms/restChannelsForm';
import BcxCareForm from './forms/bcxCareForm';
import SBSTISalesForm from './forms/sbsTiSalesForm';
import DealerForm from './forms/dealerForm';
import CorpStoreForm from './forms/corpStoreForm';
import TelusSalesManagerForm from './forms/telusSalesManagerForm';
import request from '../utils/request';
import { sortedObjects, useFormikScrollToError } from '../utils/utils';

const salesManagerForm = ({
  labels,
  schema,
  onSubmit,
  initialValues,
  loading,
  onChange,
  showModal,
  confirmationDialog,
  errorMessages,
  channelsList,
  provincesList,
  isRedirectedFromPassport
}) => {
  const {
    headerLinks: { province, channelss, supportchaneels, selectoption, Select_PROVINCE, Select_Channels },
    USERS: {
      USER_AUTHENTICATION: {
        REGISTRATION_SCHEMA_MESSAGES: {
          CHANNELORGCODE_REQUIRED,
          STORECODE_REQUIRED,
          DEALERSHIP_REQUIRED,
          CPMS_REQUIRED,
          XID_REQUIRED,
          OUTLET_REQUIRED,
          SALES_MANAGER_REQUIRED,
          SALES_MANAGER_EMAIL_REQUIRED
        }
      }
    }
  } = getLocalizedStrings();
  const {
    KEYS: { CHANNELS, ROLES }
  } = CONSTANT;

  const roles = [
    {
      text: 'Sales Rep',
      value: 'SALES_REP'
    },
    {
      text: 'Sales Manager',
      value: 'SALES_MANAGER'
    },
    {
      text: 'Sales Support',
      value: 'SALES_SUPPORT'
    }
  ];

  const [validDomains, setValidDomain] = useState([]);
  var [channelArray, setChannelArray] = useState([]);
  var [provinceArray, setProvinceArray] = useState([]);

  const techChannels = () => {
    return channelsList.filter(item => {
      return ['ADT', 'CSD', 'NBD'].includes(item.value);
    });
  };

  const salesRepChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const salesManagerChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const salesSupportChannels = () => {
    return channelsList.filter(item => {
      return item.value;
    });
  };

  const getChannels = role => {
    let tempChannels = salesRepChannels();
    if (role === 'ADT_RETENTION') {
      tempChannels = [...channels, ...referalChannels];
    }
    if (role === 'TECH') {
      tempChannels = [...techChannels()];
    }
    if (role === 'SALES_REP') {
      tempChannels = [...salesRepChannels()];
    }
    if (role === 'SALES_MANAGER') {
      tempChannels = [...salesManagerChannels()];
    }
    if (role === 'SALES_SUPPORT') {
      tempChannels = [...salesSupportChannels()];
    }
    tempChannels.sort((a, b) =>
      // eslint-disable-next-line no-nested-ternary
      a.text > b.text ? 1 : b.text > a.text ? -1 : 0
    );
    return tempChannels || [];
  };

  const getDomains = () => {
    request.get(`/domains`).then(response => {
      if (response && response.status === 200) {
        if (response.data && response.data.rows && response.data.rows.length) {
          setValidDomain(response.data.rows);
        }
      }
    });
  };

  const getChannel = outletValue => {
    let result = '';
    Object.keys(channelOutletMapping).forEach(channel => {
      if (_.get(channelOutletMapping, channel, []).includes(outletValue))
        result = channelsList.filter(ch => ch.label === channel);
    });
    return result;
  };

  const getMappedStoreCode = outletId => {

    return outletIdStoreCodeMapping[outletId] || null;
};

  // const getNameOfSelectedChannel = (tempChannelsList, value) => {
  //   value = _.get(value, '0', '')
  //   /* eslint-disable react/prop-types */
  //   let channelOptions = '';
  //   try {
  //     channelOptions =
  //       tempChannelsList.filter(item => item.id === value)[0].label || '';
  //   } catch (err) {
  //     channelOptions = '';
  //   }
  //   return channelOptions;
  //   /* eslint-disable react/prop-types */
  // };

  const getChannelData = channel => {
    let channelArr = channelsList.filter(item => item.value === channel);
    return _.get(channelArr, '0', '');
  };

  useEffect(() => {
    getDomains();
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values, actions) => {
        onSubmit(values, actions);
      }}
      validate={values => {
        const errors = {};
        if (values.email.includes('@')) {
          const domain = values.email.substring(
            values.email.lastIndexOf('@') + 1
          );
          if (
            !validDomains.some(el => {
              return el.name === domain;
            })
          ) {
            errors.email = errorMessages.INVALID_EMAIL_DOMAIN;
          }
        }
        // DEALERSHIP REQUIRED
        if (
          values.role !== ROLES.SALES_SUPPORT &&
          !values.dealership &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER))
        ) {
          errors.dealership = DEALERSHIP_REQUIRED;
        }
        // CHANNEL_ORG CODE REQUIRED
        if (
          values.role === ROLES.SALES_MANAGER &&
          !values.channelOrgCode
        ) {
          errors.channelOrgCode = CHANNELORGCODE_REQUIRED;
        }
        if (
          values.role !== ROLES.SALES_SUPPORT &&
          !values.channelOrgCode &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.DEALER))
        ) {
          errors.channelOrgCode = CHANNELORGCODE_REQUIRED;
        }
        // STORE CODE REQUIRED
        if (
          !values.storeCode &&
          values.channels &&
          values.channels.includes(getChannelData(CHANNELS.CORP_STORE))
        ) {
          errors.storeCode = STORECODE_REQUIRED;
        }
        //CPMS REQUIRED
        if (
          ![ROLES.SALES_SUPPORT, ROLES.SALES_MANAGER].includes(values.role) &&
          !values.cpmsId &&
          !values.channels.includes(getChannelData(CHANNELS.BCX_CARE)) &&
          !values.channels.includes(getChannelData(CHANNELS.ADT)) &&
          !values.channels.includes(getChannelData(CHANNELS.HEALTH)) &&
          !values.channels.includes(getChannelData(CHANNELS.CSD)) &&
          !values.channels.includes(getChannelData(CHANNELS.NBD))
        ) {
          errors.cpmsId = CPMS_REQUIRED;
        }
        //XID REQUIRED
        if (
          !values.xid &&
          ([ROLES.SALES_SUPPORT].includes(values.role) ||
            values.channels.includes(getChannelData(CHANNELS.BCX_CARE)) ||
            values.channels.includes(getChannelData(CHANNELS.HEALTH)) ||
            values.channels.includes(getChannelData(CHANNELS.CSD)) ||
            values.channels.includes(getChannelData(CHANNELS.NBD)) ||
            values.channels.includes(getChannelData(CHANNELS.ADT)))
        ) {
          errors.xid = XID_REQUIRED;
        }
        //OUTLET REQUIRED
        if (
          !values.outlet &&
          ![ROLES.SALES_SUPPORT].includes(values.role) &&
          ((values.channels &&
            !values.channels.includes(getChannelData(CHANNELS.BCX_CARE)) &&
            !values.channels.includes(getChannelData(CHANNELS.ADT)) &&
            !values.channels.includes(getChannelData(CHANNELS.HEALTH)) &&
            !values.channels.includes(getChannelData(CHANNELS.CSD)) &&
            !values.channels.includes(getChannelData(CHANNELS.NBD))) ||
            (!values.channels && values.role))
        ) {
          errors.outlet = OUTLET_REQUIRED;
        }
        //SALES MANAGER REQUIRED
        if (
          !values.salesManager &&
          [ROLES.SALES_REP, ROLES.SALES_MANAGER, ROLES.SALES_SUPPORT].includes(
            values.role
          )
        ) {
          errors.salesManager = SALES_MANAGER_REQUIRED;
        }
        // SALES MANAGER EMAIL REQUIRED
        if (
          !values.salesManagerEmail &&
          [ROLES.SALES_REP, ROLES.SALES_MANAGER, ROLES.SALES_SUPPORT].includes(
            values.role
          )
        ) {
          errors.salesManagerEmail = SALES_MANAGER_EMAIL_REQUIRED;
        }

        return errors;
      }}
    >
      {({
        handleSubmit,
        errors,
        touched,
        values,
        setFieldValue,
        isValidating,
        isSubmitting
      }) => {
        useFormikScrollToError(isSubmitting, isValidating, errors);
        return (
          <Form onSubmit={handleSubmit}>
            <div
              className="main-content-form-headers"
              style={{ marginTop: 20 }}
            >
              <span className="select-placeholder">{labels.USER_ROLE}</span>
            </div>
            <div
              style={{ position: 'relative', width: '100%' }}
              className={`frg-select-container color-light input-container ${errors.role && touched.role ? 'error' : ''
                }`}
            >
              <Field as="select"
                name="role" className="select-style">
                <option style={{ color: '#c3bfbf' }} disabled selected={!(touched && touched.role)} value="">
                  {selectoption}
                </option>
                {roles &&
                  roles.length > 0 &&
                  sortedObjects(roles, 'text').map(role => (
                    <option value={role.value}>{role.text}</option>
                  ))}
              </Field>
              <>
                <div className="error_messages">
                  <span className="registration-error">{errors.role}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            {values.role === 'SALES_SUPPORT' && (
              <Wrapper>
                <div>
                  <span className="registration-error" style={{ color:'red' }}>
                    <b style={{ color:'red' }}>{labels.NOTE}</b>: {labels.Role_Note}
                  </span>
                </div>
              </Wrapper>
            )}
            </div>
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.FIRST_NAME}</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.firstName && touched.firstName ? 'error' : ''
                }`}
            >
              {showModal && (
                <RegistrationModal show labels={confirmationDialog} />
              )}
              <Field
                name="firstName"
                type="text"
                className="select-style"
                placeholder={labels.FIRST_NAME}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <span className="registration-error">{errors.firstName}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.LAST_NAME}</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.lastName && touched.lastName ? 'error' : ''
                }`}
            >
              <Field
                name="lastName"
                type="text"
                className="select-style"
                placeholder={labels.LAST_NAME}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <span className="registration-error">{errors.lastName}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.EMAIL}</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.email && touched.email ? 'error' : ''
                }`}
            >
              <Field
                name="email"
                type="email"
                className="select-style"
                style={{ width: '100%' }}
                // onChange={(event) => {
                //   const domain = event.target.value.substring(event.target.value.lastIndexOf("@") +1);
                //   console.log('Domains: ', domain);
                // }}
                placeholder={labels.PLACEHOLDER_EMAIL}
                disabled={isRedirectedFromPassport}
              />
              <>
                <div className="error_messages">
                  <span className="registration-error">{errors.email}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>

            <Wrapper>
              <div>
                <span className="registration-error">
                  <b>{labels.NOTE}</b>: {labels.EMAIL_MESSAGE}
                </span>
              </div>
            </Wrapper>
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.PASSWORD}</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.password && touched.password ? 'error' : ''
                }`}
            >
              <Field
                type="password"
                name="password"
                style={{ width: '100%' }}
                placeholder={labels.PLACEHOLDER_PASSWORD}
                className="select-style"
              />
              <>
                <div className="error_messages">
                  <span className="registration-error">{errors.password}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>

            <PasswordMessage />
            <div className="main-content-form-headers">
              <span className="select-placeholder">
                {labels.CONTACT_NUMBER}
              </span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.contactNumber && touched.contactNumber ? 'error' : ''
                }`}
            >
              <Field
                placeholder={labels.CONTACT_NUMBER}
                name="contactNumber"
                className="select-style"
                type="text"
              />
              <>
                <div className="error_messages">
                  <span className="registration-error">
                    {errors.contactNumber}
                  </span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            {useEffect(() => {
              /* eslint-disable no-param-reassign */
              values.channels = [];
              values.channelOrgCode = '';
              values.cpmsId = '';
              values.dealership = '';
              values.salesManager = '';
              values.salesManagerEmail = '';
              values.xid = '';
              values.outlet = '';
              channelArray = [];
              /* eslint-disable no-param-reassign */
            }, [values.role])}
            {useEffect(() => {
              /* eslint-disable no-param-reassign */
              values.channelOrgCode = '';
              values.cpmsId = '';
              values.dealership = '';
              values.salesManager = '';
              values.salesManagerEmail = '';
              values.xid = '';
              values.storeCode = '';
              /* eslint-disable no-param-reassign */
            }, [values.channels])}
            {values.role && (
              <>
                <div
                  className="main-content-form-headers"
                  style={{ marginTop: 20 }}
                >
                  <span className="select-placeholder">
                    {province}
                  </span>
                </div>
                <div
                  style={{ position: 'relative', width: '100%' }}
                  className={`frg-select-container color-light input-container ${errors.provinces && touched.provinces ? 'error' : ''
                    }`}
                >
                  {values.role === 'SALES_SUPPORT' ? (
                    <>
                      {provincesList &&
                        provincesList.length > 0 &&
                        provincesList.map(province => {
                          return (
                            <Checkbox
                              checked={_.find(provincesList, province.value)}
                              name="province"
                              value={province.value}
                              onChange={e => {
                                if (!e.target.checked) {
                                  const idx = provinceArray.indexOf(province);
                                  provinceArray.splice(idx, 1);
                                  values.provinces = provinceArray;
                                  setFieldValue({ ...values });
                                  setProvinceArray(provinceArray);
                                }
                                if (e.target.checked) {
                                  provinceArray.push(province);
                                  values.provinces = provinceArray;
                                  setFieldValue({ ...values });
                                  setProvinceArray(provinceArray);
                                }
                              }}
                              label={_.get(province, 'value', '')}
                            />
                          );
                        })}
                    </>
                  ) : (
                    <Field
                      as="select"
                      name="provinces"
                      placeholder="Select Group (Just one)"
                      className="select-style"
                    >
                      <option style={{ color: '#c3bfbf' }} disabled selected={!(touched && touched.role)} value="">
                        {Select_PROVINCE}
                      </option>
                      {provincesList &&
                        provincesList.length > 0 &&
                        provincesList.map(province => (
                          <option value={province.value}>{province.value}</option>
                        ))}
                    </Field>
                  )}
                  <>
                    <div className="error_messages">
                      <span className="registration-error">
                        {errors.provinces}
                      </span>
                    </div>
                    <div
                      id="username_error_icon"
                      className="error_messages_icon"
                    >
                      <img src={ErrorIcon} alt="error_icon" />
                    </div>
                  </>
                </div>

                {values.role &&
                  ![
                    ROLES.TELUS_MANAGER,
                    ROLES.ADT_RETENTION,
                    ROLES.TECH,
                    ROLES.CBM,
                    ROLES.EPP
                  ].includes(values.role) && (
                    <Box>
                      <div
                        className="main-content-form-headers"
                        style={{ marginTop: 20 }}
                      >{values.role === 'SALES_SUPPORT' ?
                        <span className="select-placeholder">
                          {supportchaneels}
                        </span>
                        :
                        <span className="select-placeholder">
                          {channelss}
                        </span>
                        }
                      </div>
                      <div
                        style={{ position: 'relative', width: '100%' }}
                        className={`frg-select-container color-light input-container ${errors.channels && touched.channels ? 'error' : ''
                          }`}
                      >
                        {values.role === 'SALES_SUPPORT' ? (
                          <>
                            {getChannels(values.role).map(data => {
                              return (
                                <Checkbox
                                  checked={_.find(
                                    getChannels(values.role),
                                    data.id
                                  )}
                                  name="channel"
                                  value={data.value}
                                  onChange={e => {
                                    if (!e.target.checked) {
                                      const idx = channelArray.indexOf(data);
                                      channelArray.splice(idx, 1);
                                      values.channels = channelArray;
                                      setFieldValue({ ...values });
                                      setChannelArray(channelArray);
                                    }
                                    if (e.target.checked) {
                                      channelArray.push(data);
                                      values.channels = channelArray;
                                      setFieldValue({ ...values });
                                      setChannelArray(channelArray);
                                    }
                                  }}
                                  label={_.get(data, 'label', '')}
                                />
                              );
                            })}
                          </>
                        ) : (
                          <Typeahead
                            clearButton
                            id="single-typehead"
                            highlightOnlyResult={true}
                            placeholder={Select_Channels}
                            labelKey="label"
                            onChange={e => {
                              setFieldValue('channels', e);
                              channelArray.push(e);
                              setChannelArray(channelArray);
                            }}
                            selected={values.channels || []}
                            options={getChannels(values.role)}
                          />
                        )}
                        <>
                          <div className="error_messages">
                            <span className="registration-error">
                              {errors.channels}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </Box>
                  )}

                {/* DEALER FORM */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) &&
                  values.channels &&
                  values.channels.includes(getChannelData(CHANNELS.DEALER)) && (
                    <DealerForm
                      values={values}
                      labels={labels}
                      channelsList={channelsList}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  )}
                {/* CORP-STORE FORM */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP
                ].includes(values.role) &&
                  values.channels &&
                  values.channels.includes(
                    getChannelData(CHANNELS.CORP_STORE)
                  ) && (
                    <CorpStoreForm
                      values={values}
                      labels={labels}
                      channelsList={channelsList}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  )}

                {([ROLES.SALES_MANAGER].includes(values.role) &&
                  !values.channels.includes(getChannelData(CHANNELS.DEALER))) && (
                    <>
                      <div className="main-content-form-headers">
                        <span className="select-placeholder">
                        {labels.CHANNEL_ORGANIZATION_CODE}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.channelOrgCode && touched.channelOrgCode ? 'error' : ''
                      }`}
                      >
                        <Field
                          placeholder={labels.PLACEHOLDER_CHANNEL_ORGANIZATION_CODE}
                          className="select-style"
                          name="channelOrgCode"
                          type="text"
                        />
                        <>
                        <div className="error_messages">
                            <span className="registration-error">
                              {errors.channelOrgCode}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {![ROLES.SALES_SUPPORT, ROLES.SALES_MANAGER].includes(values.role) &&
                  ((values.channels &&
                    !values.channels.includes(
                      getChannelData(CHANNELS.BCX_CARE)
                    ) &&
                    !values.channels.includes(getChannelData(CHANNELS.ADT)) &&
                    !values.channels.includes(
                      getChannelData(CHANNELS.HEALTH)
                    ) &&
                    !values.channels.includes(getChannelData(CHANNELS.CSD)) &&
                    !values.channels.includes(getChannelData(CHANNELS.NBD))) ||
                    (!values.channels && values.role)) && (
                    <>
                      <div className="main-content-form-headers">
                        <span className="select-placeholder">
                          {labels.CPMS_ID}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.cpmsId && touched.cpmsId ? 'error' : ''
                          }`}
                      >
                        <Field
                          placeholder={labels.CPMS_ID}
                          className="select-style"
                          name="cpmsId"
                          type="text"
                        // validate={validateCPMS}
                        />
                        <>
                          <div className="error_messages">
                            <span className="registration-error">
                              {errors.cpmsId}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {/* OUTLET ID PART */}
                {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) &&
                  ((values.channels &&
                    !values.channels.includes(
                      getChannelData(CHANNELS.BCX_CARE)
                    ) &&
                    !values.channels.includes(getChannelData(CHANNELS.ADT)) &&
                    !values.channels.includes(
                      getChannelData(CHANNELS.HEALTH)
                    ) &&
                    !values.channels.includes(getChannelData(CHANNELS.CSD)) &&
                    !values.channels.includes(getChannelData(CHANNELS.NBD))) ||
                    (!values.channels && values.role)) && (
                    <>
                      <div className="main-content-form-headers">
                        <span className="select-placeholder">
                          {labels.OUTLET}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.outlet && touched.outlet ? 'error' : ''
                          }`}
                      >
                        <Field
                          type="text"
                          placeholder={labels.OUTLET}
                          className="select-style"
                          name="outlet"
                          value={values.outlet}
                          onChange={({ target: { value } }) => {
                            setFieldValue('outlet', value);
                            const mappedChannel = getChannel(value);
                            if (mappedChannel)
                              setFieldValue('channels', mappedChannel);
                            const mappedStoreCode = getMappedStoreCode(value);
                            if(mappedStoreCode)
                                setFieldValue('storeCode',mappedStoreCode);
                          }}
                        />
                        <>
                          <div className="error_messages">
                            <span className="registration-error">
                              {errors.outlet}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}

                {/* XID PART */}
                {([ROLES.SALES_SUPPORT].includes(values.role) ||
                  values.channels.includes(getChannelData(CHANNELS.BCX_CARE)) ||
                  values.channels.includes(getChannelData(CHANNELS.HEALTH)) ||
                  values.channels.includes(getChannelData(CHANNELS.CSD)) ||
                  values.channels.includes(getChannelData(CHANNELS.NBD)) ||
                  values.channels.includes(getChannelData(CHANNELS.ADT)) ||
                  values.channels.includes(getChannelData(CHANNELS.CORP_STORE))) && (
                    // , ROLES.SALES_SUPPORT [SOF-1750] Removed this because it's displaying twice in the sales support role
                    // This is commented because xid should be displayed if role = ADT Retention
                    // [CHANNELS.HOME_SOLUTION].includes(values.channels)
                    <>
                      <div className="main-content-form-headers">
                        <span className="select-placeholder">
                          {labels.XID_TID}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${errors.xid && touched.xid ? 'error' : ''
                          }`}
                      >
                        <Field
                          placeholder={labels.XID_TID_PLACEHOLDER}
                          className="select-style"
                          type="text"
                          name="xid"
                        />
                        <>
                          <div className="error_messages">
                            <span className="registration-error">
                              {errors.xid}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </>
                  )}
                {[
                  ROLES.SALES_REP,
                  ROLES.SALES_MANAGER,
                  ROLES.SALES_SUPPORT
                ].includes(values.role) && (
                    <RestChannelsForm
                      values={values}
                      labels={labels}
                      touched={touched}
                      errors={errors}
                    />
                  )}
                {/* BCX Care Form */}
                {/* {![
                  ROLES.TELUS_MANAGER,
                  ROLES.TECH,
                  ROLES.ADT_RETENTION,
                  ROLES.CBM,
                  ROLES.EPP
                ].includes(values.role) &&
                  values.channels &&
                  values.channels.includes(getChannelData(CHANNELS.BCX_CARE)) && (
                    <BcxCareForm
                      values={values}
                      labels={labels}
                      touched={touched}
                      errors={errors}
                    />
                  )} */}

                {/* TelusSalesManagerForm */}
                {/* {(![
              ROLES.TELUS_MANAGER,
              ROLES.ADT_RETENTION,
              ROLES.CBM,
              ROLES.EPP,
              ROLES.SALES_REP,
              ROLES.SALES_MANAGER
            ].includes(values.role) &&
              values.channels &&
              !values.channels.includes(getChannelData(CHANNELS.DEALER))) ||
              (values.channels.includes(getChannelData(CHANNELS.HOME_SOLUTION)) && (
                <TelusSalesManagerForm
                  values={values}
                  labels={labels}
                  touched={touched}
                  errors={errors}
                />
              ))}
            {[ROLES.CBM, ROLES.EPP].includes(values.role) && (
              <TelusSalesManagerForm
                values={values}
                labels={labels}
                touched={touched}
                errors={errors}
              />
            )} */}
              </>
            )}
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.recaptcha && touched.recaptcha ? 'error' : ''
                }`}
            >
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                name="recaptcha"
                onChange={onChange}
              />
            </div>

            <div
              id="continue_button"
              style={{ marginTop: 20, textAlign: 'center' }}
            >
              {!loading ? (
                <span>
                  <button
                    type="submit"
                    className="frg-button button-wide color-green"
                  >
                    {confirmationDialog.confirm}
                  </button>
                </span>
              ) : (
                <span>
                  <button
                    className="frg-button button-wide color-green"
                    type="button"
                  >
                    <i className="fa fa-refresh fa-spin" />
                    {confirmationDialog.LOADING}
                  </button>
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default salesManagerForm;
